module.exports = __webpack_public_path__ + "media/images/home/close-1d99814f3f967f6094a2314ede8b8d86.svg";